<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="ch3"> </p>
<p class="img"><img alt="image" height="357" src="images/pg-11.jpg" width="373"/></p>
<p class="half-space"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter3.vue?78b8eb0f